const VALUE_WITH_LOYALTY = 1

const VALUE_WITHOUT_LOYALTY = 0

const FIXED_INTERNET = "INTERNET_FIXA"
const MOBILE_INTERNET = "MOVEL"
const FIXED_PHONE = "TELEFONE_FIXO"
const ADDITIONAL_SERVICES = "SVA"
const TV = "TV"

const BRADESCO_BANK = 237
const BANCO_DO_BRASIL_BANK = 1

const ENDPOINT_API_V2 = "/v2/"

const LOYALTY = { 1: "Fidelizado", 0: "Não fidelizado" }

const LENGTH_POSTCODE = 8

const SEARCH_CEP =
  "https://buscacepinter.correios.com.br/app/endereco/index.php"

const MASK_BANKS = {
  237: "#######-X",
  341: "#####-#",
  260: "######-#",
  33: "########-#",
  1: "########-X",
  104: "###########-#",
  77: "#######-#"
}

const ICONS_FEEDBACK = {
  warn: "exclamation-circle",
  error: "exclamation-circle",
  info: "info-circle",
  success: "check-circle",
  finish: "check-circle"
}

const ICONS_INDICATORS = {
  success: "check-circle",
  error: "x-circle",
  waiting: "clock",
  pending: "alert-triangle",
  inProgress: "settings",
  finish: "check-circle",
  installation: "tool"
}

const PAYMENT_AVAILABLE = {
  DIGITAL: "E-mail ( fatura digital )",
  CORREIOS: "Correios ( fatura impressa )"
}

const SERVICES = {
  MIGRACAO: "Migração",
  PORTABILIDADE: "Portabilidade",
  ATIVACAO: "Ativação"
}

const PAYMENT_TYPE = {
  DEBITO_AUTOMATICO: "Débito automático",
  BOLETO: "Boleto bancário",
  CARTAO_CREDITO: "Cartão de crédito"
}

const MODALITIES = {
  CONTROLE_BOLETO: "Controle boleto",
  POS_PAGO: "Pós pago",
  CONTROLE_FACIL: "Controle fácil",
  PRE_PAGO: "Pré pago",
  CONTROLE_FACIL_BOLETO: "Controle fácil boleto",
  CONTROLE: "Controle",
  EXPRESS: "Express",
  TVPRE: "TV Pré",
  RESIDENCIAL: "Residencial"
}

const STATUS_FEEDBACK = {
  CANCELADO: "error",
  EM_PROCESSAMENTO: "info",
  PENDENTE: "warn",
  CONCRETIZADO: "success",
  EM_ANALISE: "success",
  EM_CONTINGENCIA: "warn",
  NAO_CONVERTIDO: "error",
  CONVERTIDO: "success",
  RCV: "success",
  INDICACAO_RECEBIDA: "success"
}

const TITLE_FEEDBACK = {
  EM_ANALISE: "Contratação Realizada",
  EM_CONTINGENCIA: "Aguardando Verificação",
  NAO_CONVERTIDO: "Falha na contratação",
  CONVERTIDO: "Contratação Realizada",
  RCV: "Contratação Realizada",
  INDICACAO_RECEBIDA: "Pedido Recebido",
  CONCRETIZADO: "Pedido ativado",
  EM_PROCESSAMENTO: "Pedido cadastrado",
  CANCELADO: "Pedido cancelado",
  PENDENTE: "Pedido pendente"
}

const FEEDBACK_VOICE_VERIFY = {
  PENDENTE: {
    status: "warn",
    title: "Pedido Pendente de Aceite de Voz",
    description:
      "O pedido já foi enviado, estamos consultado no sistema junto a Claro para identificar a realização do Aceite de Voz realizado pelo cliente."
  },
  SAIDA_ACEITE_VOZ: {
    status: "warn",
    title: "Pedido Pendente de Aceite de Voz",
    description:
      "O pedido ainda não foi enviado, devido a ausência do aceite de voz, necessário para o procecimento de contratação do plano junto a Claro. Realize o aceite de voz para o pedido ser concluído."
  },
  NAO_ACEITO: {
    status: "error",
    title: "Pedido Cancelado",
    description:
      "Esse pedido foi cancelado e não pode ser registrado ou comissionado. Inicie uma nova venda clicando abaixo."
  },
  ACEITO: {
    status: "success",
    title: "Pedido Concretizado",
    description:
      "Pedido Enviamos uma mensagem com todos os detalhes do pedido para o e-mail do cliente cadastrado nas etapas iniciais do pedido."
  }
}

const DEFAULT_ENDPOINT = "hub"

const ICONS_PNG_FREE_APPS_COMPARATIVE = [
  "claromusica",
  "clarovideo",
  "claronoticias",
  "clarobanca",
  "now",
  "skeelo",
  "netflix",
  "youtube",
  "plutotv",
  "globoplay",
  "twitch"
]

const ITEMS_PER_PAGE = 20

const STATUS_SALE = {
  EM_PROCESSAMENTO: {
    text: "Processando",
    type: "active"
  },
  PENDENTE: {
    text: "Pendente",
    type: "warn"
  },
  CONCRETIZADO: {
    text: "Concretizado",
    type: "success"
  },
  CANCELADO: {
    text: "Cancelado",
    type: "error"
  },
  ABANDONADO: {
    text: "Abandonado",
    type: "disabled"
  }
}

const ICONS_PER_STATUS_SALE = {
  CONCRETIZADO: "check-circle",
  CANCELADO: "x-circle",
  ABANDONADO: "shopping-bag",
  PENDENTE: "alert-triangle",
  EM_PROCESSAMENTO: "settings"
}

const SUB_STATUS_SALE = {
  ATIVACAO: "Ativação",
  ACEITE_VOZ: "Aceite de voz",
  ICCID_USO: "ICCID em uso",
  VENCIMENTO_INVALIDO: "Venc. inválido",
  DADO_BANCARIO_INVALIDO: "Dados bancários inválidos",
  PLANO_INVALIDO: "Oferta inválida",
  ACEITE_DECLINADO: "Aceite Declinado",
  ACEITE_NAO_REALIZADO: "Aceite não realizado",
  SUSPEITA_FRAUDE: "Susp. de fraude",
  CREDITO_INSUFICIENTE: "Créd. Insuficiente",
  CANCELADO_SVC: "Canc. SVC",
  DOWNGRADE: "Downgrade",
  EM_TRATAMENTO: "Em tratamento",
  INDICACAO_RECEBIDA: "Ind. recebida",
  MENOR_IDADE: "Menor idade",
  CLIENTE_NAO_ENCONTRADO: "Cliente não encontrado",
  PAGAMENTO_NAO_AUTORIZADO: "Pagamento não autorizado",
  PAGAMENTO_REALIZADO: "Pagamento realizado",
  PAGAMENTO_PENDENTE: "Pagamento Pendente",
  AGUARDANDO_PAGAMENTO: "Pagamento pendente",
  PAGAMENTO_ANALISE: "Pagamento em análise",
  PENDENTE: "Pendente",
  ENVIADO: "Enviado",
  ENTREGUE: "Entregue",
  PEDIDO_ENVIADO: "Pedido enviado",
  PEDIDO_REALIZADO: "Pedido realizado",
  AGUARDANDO_BKO: "Aguardando BKO",
  EMITIDA: "Emitida",
  SCORE_NEGADO: "Score negado",
  SEM_COBERTURA: "Sem cobertura",
  DESCONHECIDO_NO_LOCAL: "Desconhecido no local",
  ENDERECO_INCORRETO: "Endereço incorreto",
  EMITIDA_EM_OUTRO_CANAL: "Emitida em outro canal",
  PRODUTO_ALVO: "Produto alvo",
  DUPLICADA: "Duplicada",
  DADOS_DIVERGENTES: "Dados divergentes",
  DESISTENCIA_DO_CLIENTE: "Desistência do cliente",
  CRUZAMENTO_DO_CANAL: "Cruzamento do canal",
  DADOS_INCORRETOS: "Dados incorretos",
  CREDITO_NEGADO: "Crédito negado",
  CREDITO_NEGADO_TELECOM: "Crédito negado",
  ERRO_CHECAGEM_CREDITO: "Erro de checagem do crédito",
  TITULAR_FALECIDO: "Titular falecido",
  INVIABILIDADE_TECNICA: "Inviabilidade técnica",
  ENDERECO_INADIMPLENTE: "Endereço inadimplente",
  TESTE: "Teste",
  JA_E_CLIENTE_NO_MESMO_ENDERECO: "Cliente no mesmo endereço",
  CREDITO_NEGADO_EM_ALGUMA_OPERADORA: "Crédito negado na operadora",
  NAO_SOUBE_CONFIRMAR_OS_DADOS: "Não soube confirmar os dados",
  INSTALADO: "Instalado",
  INSTALANDO: "Instalando",
  TRANSFERIDO: "Transferido"
}

const MOBILE_SALES_FLOW_STEP_LABELS = {
  OPENING: "Abertura",
  REGISTER: "Cadastro",
  OFFER: "Oferta",
  PAYMENT: "Pagamento",
  CONFIRMATION: "Confirmação",
  ACCEPTANCE: "Aceite"
}

const MOBILE_SALES_FLOW_ROUTE_LABELS = {
  OPENING_SALE: "opening-sale",
  COMPLETE_REGISTRATION: "complete-registration",
  AVAILABLE_OFFERS: "available-offers",
  CUSTOMIZE_INVOICE: "customize-invoice",
  ORDER_CONFIRMATION: "order-confirmation",
  ORDER_ACCEPTANCE: "order-acceptance"
}

const STATUS_MISSIONS_NEAR_SCHEDULED_ACTIVE_DELAYED = [
  "PROXIMA",
  "AGENDADA",
  "ATRASADA",
  "ATIVA"
]

const STATUS_MISSIONS_NEAR_SCHEDULED_DELAYED = [
  "PROXIMA",
  "AGENDADA",
  "ATRASADA"
]

const STATUS_MISSIONS_CANCELLED_FINISHED = ["CONCLUIDA", "CANCELADA"]

const MISSION_STATUS_BADGE = {
  DISPONIVEL: "info-teal",
  AGENDADA: "success",
  CONCLUIDA: "disabled",
  CANCELADA: "error",
  PROXIMA: "warn",
  ATRASADA: "warn",
  ATIVA: "active",
  SEM_ACEITE: "warn",
  NAO_EXECUTADA: "error"
}

const MISSION_TEXT_BADGE = {
  DISPONIVEL: "disponível",
  AGENDADA: "agendada",
  CONCLUIDA: "concluída",
  CANCELADA: "cancelada",
  ATIVA: "Ativa",
  PROXIMA: "Próxima",
  ATRASADA: "Atrasada",
  SEM_ACEITE: "Sem aceite",
  NAO_EXECUTADA: "Não executada"
}

const COMMISSION_TYPES_TEXT = {
  VENDA: "Comissão",
  TRANSFERENCIA: "Transferência",
  DIARIA: "Diária",
  COMISSAO: "Comissão",
  BONUS: "Bônus",
  ACESSO: "Acesso",
  COMPARTILHAMENTO: "Compartilhamento"
}

const DEFAULT_TOTAL_ITEMS_PER_PAGE = process.env
  .VUE_APP_TOTAL_ITEMS_PER_PAGE || [
  { text: "15", value: "15" },
  { text: "20", value: "20" },
  { text: "50", value: "50" },
  { text: "100", value: "100" },
  { text: "150", value: "150" }
]

const { OPENING, REGISTER, OFFER, PAYMENT, CONFIRMATION, ACCEPTANCE } =
  MOBILE_SALES_FLOW_STEP_LABELS

const {
  OPENING_SALE,
  COMPLETE_REGISTRATION,
  AVAILABLE_OFFERS,
  CUSTOMIZE_INVOICE,
  ORDER_CONFIRMATION,
  ORDER_ACCEPTANCE
} = MOBILE_SALES_FLOW_ROUTE_LABELS

const STEP_ROUTES = {
  [OPENING_SALE]: 1,
  [COMPLETE_REGISTRATION]: 2,
  [AVAILABLE_OFFERS]: 3,
  [CUSTOMIZE_INVOICE]: 4,
  [ORDER_CONFIRMATION]: 5,
  [ORDER_ACCEPTANCE]: 6
}

const ROUTES_PER_STEP = {
  [OPENING_SALE]: OPENING,
  [COMPLETE_REGISTRATION]: REGISTER,
  [AVAILABLE_OFFERS]: OFFER,
  [CUSTOMIZE_INVOICE]: PAYMENT,
  [ORDER_CONFIRMATION]: CONFIRMATION,
  [ORDER_ACCEPTANCE]: ACCEPTANCE
}

export {
  VALUE_WITH_LOYALTY,
  VALUE_WITHOUT_LOYALTY,
  LOYALTY,
  LENGTH_POSTCODE,
  MASK_BANKS,
  PAYMENT_AVAILABLE,
  PAYMENT_TYPE,
  SERVICES,
  MODALITIES,
  STATUS_FEEDBACK,
  TITLE_FEEDBACK,
  DEFAULT_ENDPOINT,
  ICONS_PNG_FREE_APPS_COMPARATIVE,
  ITEMS_PER_PAGE,
  MISSION_STATUS_BADGE,
  MISSION_TEXT_BADGE,
  STATUS_MISSIONS_NEAR_SCHEDULED_ACTIVE_DELAYED,
  STATUS_MISSIONS_CANCELLED_FINISHED,
  STATUS_MISSIONS_NEAR_SCHEDULED_DELAYED,
  DEFAULT_TOTAL_ITEMS_PER_PAGE,
  COMMISSION_TYPES_TEXT,
  STATUS_SALE,
  SUB_STATUS_SALE,
  MOBILE_SALES_FLOW_STEP_LABELS,
  MOBILE_SALES_FLOW_ROUTE_LABELS,
  FEEDBACK_VOICE_VERIFY,
  ICONS_PER_STATUS_SALE,
  ICONS_FEEDBACK,
  ICONS_INDICATORS,
  SEARCH_CEP,
  ENDPOINT_API_V2,
  FIXED_INTERNET,
  MOBILE_INTERNET,
  STEP_ROUTES,
  ROUTES_PER_STEP,
  BRADESCO_BANK,
  BANCO_DO_BRASIL_BANK,
  ADDITIONAL_SERVICES,
  FIXED_PHONE,
  TV
}

export const STATES = [
  { value: 0, text: "Selecione...", acronym: "" },
  { value: 1, text: "Acre", acronym: "AC" },
  { value: 2, text: "Alagoas", acronym: "AL" },
  { value: 3, text: "Amazonas", acronym: "AM" },
  { value: 4, text: "Amapá", acronym: "AP" },
  { value: 5, text: "Bahia", acronym: "BA" },
  { value: 6, text: "Ceará", acronym: "CE" },
  { value: 7, text: "Distrito Federal", acronym: "DF" },
  { value: 8, text: "Espírito Santo", acronym: "ES" },
  { value: 9, text: "Goiás", acronym: "GO" },
  { value: 10, text: "Maranhão", acronym: "MA" },
  { value: 11, text: "Minas Gerais", acronym: "MG" },
  { value: 12, text: "Mato Grosso do Sul", acronym: "MS" },
  { value: 13, text: "Mato Grosso", acronym: "MT" },
  { value: 14, text: "Pará", acronym: "PA" },
  { value: 15, text: "Paraíba", acronym: "PB" },
  { value: 16, text: "Pernambuco", acronym: "PE" },
  { value: 17, text: "Piauí", acronym: "PI" },
  { value: 18, text: "Paraná", acronym: "PR" },
  { value: 19, text: "Rio de Janeiro", acronym: "RJ" },
  { value: 20, text: "Rio Grande do Norte", acronym: "RN" },
  { value: 21, text: "Rondônia", acronym: "RO" },
  { value: 22, text: "Roraima", acronym: "RR" },
  { value: 23, text: "Rio Grande do Sul", acronym: "RS" },
  { value: 24, text: "Santa Catarina", acronym: "SC" },
  { value: 25, text: "Sergipe", acronym: "SE" },
  { value: 26, text: "São Paulo", acronym: "SP" },
  { value: 27, text: "Tocantins", acronym: "TO" }
]
